module.exports = __webpack_public_path__ + "assets/media/bottle-about.7817b153.svg";